export const HOME_MODULE_NAMESPACE = 'home'
export const HOME_GET_TICKETS = 'HOME_GET_TICKETS'
export const HOME_GET_MEMBERS = 'HOME_GET_MEMBERS'
export const HOME_GET_LOADING = 'HOME_GET_MEMBERS_LOADING'
export const HOME_GET_BLOCK = 'HOME_GET_BLOCK'
export const HOME_GET_TICKET_BY_CONTRACTOR = 'HOME_GET_TICKET_BY_CONTRACTOR'
export const HOME_GET_SERVICE_BOOK = 'HOME_GET_SERVICE_BOOK'


// WEBPACK FOOTER //
// ./src/store/home/home-types.store.ts